/**
 * Get previous HTML element which is visible.
 *
 * @see https://stackoverflow.com/a/21696585/5506547
 */
function getPreviousVisibleElement(node) {
  var found = node;

  while (found.previousElementSibling ? !((_found$previousElemen = found.previousElementSibling) !== null && _found$previousElemen !== void 0 && _found$previousElemen.offsetParent) : false) {
    var _found$previousElemen;

    found = found.previousElementSibling;
  }

  return found.offsetParent ? found : undefined;
}

export { getPreviousVisibleElement };